<script lang="ts" setup>
import type { ComponentBlockMemberListFragment } from "~~/types/graphql";

const props = defineProps<{
  MemberHeadline: ComponentBlockMemberListFragment["MemberHeadline"];
  Members: ComponentBlockMemberListFragment["Members"];
}>();
</script>
<template>
  <LayoutBlock class="member-list">
    <div :class="$props.MemberHeadline ? 'grid lg:grid-cols-[1fr_3fr]' : ''">
      <div v-if="props.MemberHeadline" class="member-headline text-xs">
        {{ MemberHeadline }}
      </div>
      <div
        class="member-item-wrapper member-grid mt-10 grid gap-x-3 gap-y-15 xs:grid-cols-2 md:grid-cols-3 lg:mt-0 lg:gap-x-6"
        :class="{ 'justify-center lg:grid-cols-4': !props.MemberHeadline }"
      >
        <div
          v-for="(item, index) in Members?.data"
          :key="`${item?.__typename}-${index}`"
          class="member-items flex flex-col content-start content-between gap-4"
        >
          <div class="flex">
            <div class="image-wrapper">
              <base-image
                v-bind="item?.attributes?.member?.image.data?.attributes"
              />
            </div>
          </div>
          <div
            v-if="
              item?.attributes?.member?.name || item?.attributes?.member?.role
            "
            class="flex flex-col"
          >
            <span
              v-if="item?.attributes?.member?.name"
              class="font-pixel text-normal font-semibold"
            >
              {{ item?.attributes?.member.name }}
            </span>
            <span v-if="item?.attributes?.member?.role" class="text-normal">
              {{ item?.attributes?.member.role }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </LayoutBlock>
</template>
